import React, { Component, Fragment } from 'react';
import {
    NavItem,
    NavLink,
    UncontrolledButtonDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem
} from 'reactstrap';
import { Link } from 'react-router-dom';
import authService from './AuthorizeService';
import { ApplicationPaths } from './ApiAuthorizationConstants';
import userFunctions from '../UserFunctions';

// SafeNavLink checks for unsaved changes before navigation
class SafeNavLink extends Component {
    //handleClick = (e) => {
    //    const { to } = this.props;
    //    e.preventDefault();

    //    // If ExamPreTest (or another page) registered a trigger
    //    if (window.triggerUnsavedCheck) {
    //        const proceed = window.triggerUnsavedCheck(to);
    //        if (proceed) {
    //            window.location.href = to;
    //        }
    //    } else {
    //        // No unsaved logic active — navigate normally
    //        window.location.href = to;
    //    }
    //};

    handleClick = (e) => {
        const { to } = this.props;
        e.preventDefault();

        // Determine the target URL
        if (typeof to === "object" && to.pathname) {
            // Preserve React Router navigation state
            window.history.pushState({ state: to.state }, '', to.pathname);

            if (window.triggerUnsavedCheck) {
                const proceed = window.triggerUnsavedCheck(to.pathname);
                if (proceed) window.location.href = to.pathname;
            } else {
                window.location.href = to.pathname;
            }
        } else {
            const targetUrl = to;
            if (window.triggerUnsavedCheck) {
                const proceed = window.triggerUnsavedCheck(targetUrl);
                if (proceed) window.location.href = targetUrl;
            } else {
                window.location.href = targetUrl;
            }
        }
    };


    render() {
        const { to, className, style, children } = this.props;
        return (
            <Link
                to={to}
                onClick={this.handleClick}
                className={className}
                style={style}
            >
                {children}
            </Link>
        );
    }
}

export class LoginMenu extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isAuthenticated: false,
            userName: null,
            formNoMatchCount: 0,
            topLevelAccessMembers: []
        };
    }

    componentDidMount() {
        this._subscription = authService.subscribe(() => this.populateState());
        this.populateState();
        this.getFormsNoMatchCount();

        this.intervalId = setInterval(async () => {
            await this.getFormsNoMatchCount();
        }, 6000);
    }

    async getFormsNoMatchCount() {
        try {
            var count = await userFunctions.FormsNoMatchCount();
            this.setState({ formNoMatchCount: count ?? 0 });

            var members = await userFunctions.TopAccessGroupMembers(false);
            this.setState({ topLevelAccessMembers: Array.isArray(members) ? members : [] });
        } catch (error) {
            console.error("Error in getFormsNoMatchCount:", error);
            this.setState({ formNoMatchCount: 0, topLevelAccessMembers: [] });
        }
    }

    componentWillUnmount() {
        authService.unsubscribe(this._subscription);
        clearInterval(this.intervalId);
    }

    async populateState() {
        const [isAuthenticated, user] = await Promise.all([
            authService.isAuthenticated(),
            authService.getUser()
        ]);

        if (user) {
            sessionStorage.setItem("UserId", user.sub);
            sessionStorage.setItem("Username", user.name);
        }

        this.setState({
            isAuthenticated,
            userName: user && user.name
        });
    }

    render() {
        const { isAuthenticated, userName } = this.state;
        if (!isAuthenticated) {
            const registerPath = `${ApplicationPaths.Register}`;
            const loginPath = `${ApplicationPaths.Login}`;
            return this.anonymousView(registerPath, loginPath);
        } else {
            const profilePath = `${ApplicationPaths.Profile}`;
            const logoutPath = { pathname: `${ApplicationPaths.LogOut}`, state: { local: true } };
            return this.authenticatedView(userName, profilePath, logoutPath);
        }
    }

    authenticatedView(userName, profilePath, logoutPath) {
        return (
            <Fragment>
                <div className="menu-items" style={{ width: 'fit-content' }}>
                    <UncontrolledButtonDropdown className="et-menu">
                        <DropdownToggle caret size="md" className="menuDropdown">
                            Search
                        </DropdownToggle>
                        <DropdownMenu>
                            <DropdownItem tag={SafeNavLink} to="/DistrictSearch">District</DropdownItem>
                            <DropdownItem tag={SafeNavLink} to="/ReplacementSearch">Replacement</DropdownItem>
                            <DropdownItem tag={SafeNavLink} to="/SiteSearch">Site</DropdownItem>
                            <DropdownItem tag={SafeNavLink} to="/StudentSearch">Student</DropdownItem>
                        </DropdownMenu>
                    </UncontrolledButtonDropdown>

                    <UncontrolledButtonDropdown className="et-menu">
                        <DropdownToggle caret size="md" className="menuDropdown">
                            Inventory
                        </DropdownToggle>
                        <DropdownMenu>
                            <DropdownItem tag={SafeNavLink} to="/FrameInventory">Frame</DropdownItem>
                            <DropdownItem tag={SafeNavLink} to="/LensInventory">Lens</DropdownItem>
                        </DropdownMenu>
                    </UncontrolledButtonDropdown>

                    <NavItem className="et-menu-item">
                        <NavLink style={{ whiteSpace: 'nowrap' }} tag={SafeNavLink} className="text-dark" to="/DoctorExamSelection">
                            Doctor Exam / Lab Selection
                        </NavLink>
                    </NavItem>

                    <NavItem className="et-menu-item">
                        <NavLink style={{ whiteSpace: 'nowrap' }} tag={SafeNavLink} className="text-dark" to="/Reporting">
                            Reporting
                        </NavLink>
                    </NavItem>

                    <NavItem className="et-menu-item">
                        <NavLink style={{ whiteSpace: 'nowrap' }} tag={SafeNavLink} className="text-dark" to="/RosterImport">
                            Roster Import
                        </NavLink>
                    </NavItem>

                    {Array.isArray(this.state.topLevelAccessMembers) &&
                        this.state.topLevelAccessMembers?.includes(userName) ? (
                        <NavItem
                            className="et-menu-item"
                            style={{
                                position: 'relative',
                                display: 'flex',
                                justifyContent: 'flex-start',
                                alignItems: 'center'
                            }}
                        >
                            <NavLink
                                style={{ whiteSpace: 'nowrap', paddingRight: '.20rem' }}
                                tag={SafeNavLink}
                                className="text-dark"
                                to="/StudentForms"
                            >
                                Forms
                            </NavLink>
                            {this.state.formNoMatchCount && this.state.formNoMatchCount > 0 ? (
                                <div
                                    style={{
                                        width: 'fit-content',
                                        height: '18px',
                                        maxHeight: '18px',
                                        marginRight: '.40rem',
                                        padding: '1px',
                                        background: '#dd0000',
                                        color: '#fff',
                                        borderRadius: '60%',
                                        minWidth: '18px',
                                        fontSize: '11px',
                                        textAlign: 'center'
                                    }}
                                >
                                    {this.state.formNoMatchCount}
                                </div>
                            ) : null}
                        </NavItem>
                    ) : null}

                    <NavItem className="et-menu-item">
                        <NavLink style={{ whiteSpace: 'nowrap' }} tag={SafeNavLink} className="text-dark" to="/DataSync">
                            Data Sync
                        </NavLink>
                    </NavItem>
                </div>

                <div className="profile-logout">
                    <NavItem>
                        <NavLink tag={SafeNavLink} className="text-dark" to={profilePath}>
                            Hello {userName}
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink tag={SafeNavLink} className="text-dark" to={logoutPath}>
                            Logout
                        </NavLink>
                    </NavItem>
                </div>
            </Fragment>
        );
    }

    anonymousView(registerPath, loginPath) {
        return (
            <Fragment>
                <NavItem>
                    <NavLink tag={SafeNavLink} className="text-dark" to={loginPath}>
                        Login
                    </NavLink>
                </NavItem>
            </Fragment>
        );
    }
}